import { useEffect } from 'react';
import { t } from 'i18next';
import './JoinPage.css';
import JoinTopBarComponent from './components/JoinTopBarComponent';
import CallToActionComponent from './components/CallToActionComponent';
import HowItWorksComponent from './components/HowItWorksComponent';
import TrustComponent from './components/TrustComponent';
import CampaignsComponent from './components/CampaignsComponent';
import FooterComponent from './components/FooterComponent';

function JoinPage() {
  useEffect(() => {
    let chg = false;
    const id = setInterval(() => {
      document.title = chg
        ? t('joinPage.slogan')
        : t('joinPage.title');
      chg = !chg;
    }, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="jp-root">
      <title>{t('joinPage.title')}</title>
      <JoinTopBarComponent />
      <CallToActionComponent />
      <HowItWorksComponent />
      <TrustComponent />
      <CampaignsComponent />
      <FooterComponent />
    </div>
  );
}

export default JoinPage;
